import { AxiosPromise } from 'axios'
import { EsimAuditLogType } from 'types/api/faber/customerAuditLog.type'

import FaberApi from '.'

class EsimAPI {
  /**
   * to resend a esim subscription email
   * @param iccid
   * @returns Promise<AxiosResponse<any, any>>
   */
  static resendEsimSubscriptionEmail(body: {
    iccid: string
    faberToken: string
  }) {
    return FaberApi.httpGet(
      `/esim/resend/${body.iccid}`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      true
    )
  }

  static getEsimAuditLogs(
    userId: string,
    faberToken: string
  ): AxiosPromise<EsimAuditLogType> {
    return FaberApi.httpGet(
      `/audit/esim/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static resendEsimEmail({
    userId,
    faberToken
  }: {
    userId: string
    faberToken: string
  }) {
    return FaberApi.httpPost(
      `/sim/ops/notification/esim/resend/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {}
    )
  }
}

export default EsimAPI
